import * as actionTypes from './actionTypes';

export const openStep = (payload) => ({ type: actionTypes.STEPS_OPEN_STEP_REQUEST, payload });
export const setStepAsCompleted = (payload) => ({ type: actionTypes.STEPS_SET_COMPLETED_REQUEST, payload });
export const setCurrentStep = (payload) => ({ type: actionTypes.STEPS_SET_CURRENT_STEP, payload });
export const setCompletedStep = (payload) => ({ type: actionTypes.STEPS_SET_COMPLETED_STEP, payload });
